
import { useAuth } from '@/hooks/useAuth';
import { Link } from 'react-router-dom';
import { HeaderAuth } from './HeaderAuth';

export const TopBanner = () => {
  const { user } = useAuth();

  return (
    <div className="bg-gradient-green text-white py-2 text-sm">
      <div className="container-custom flex justify-between items-center">
        <div className="hidden md:flex space-x-4">
          <span>📞 Call us: 061 321 5050</span>
          <span>📧 Email: info@veevoerwinkel.co.za</span>
        </div>
        <div className="flex space-x-4 ml-auto">
          {user ? (
            <Link to="/orders" className="hover:text-gold-400 transition-colors">
              My Orders
            </Link>
          ) : (
            <Link to="/login?redirect=/orders" className="hover:text-gold-400 transition-colors">
              My Orders
            </Link>
          )}
          <Link to="/blog" className="hover:text-gold-400 transition-colors">
            Blog
          </Link>
          <Link to="/contact" className="hover:text-gold-400 transition-colors">
            Contact
          </Link>
          <HeaderAuth />
        </div>
      </div>
    </div>
  );
};
